<template>

  <div class="main-top">
    
    <div class="search-wrap">
      <div style="flex:1">
        <search-from>
        <template slot="default">
          <slot name="default"></slot>
        </template>
        <template slot="shrink">
          <slot name="shrink"></slot>
        </template>
      </search-from>
      <slot name="searchForm"></slot>
      </div>
      <div class="query-wrap">
        <slot name="query"></slot>
        <div class="elRow">
            <!-- <f-button v-if="show==false" icon="unfold" @click="handleClick(true)" :icon-size="14">展开</f-button>
            <f-button v-if="show==true" icon="packup" @click="handleClick(false)" :icon-size="14">收起</f-button> -->
            <div v-if="show==false"  @click="handleClick(true)">
              <span style="padding-left:2px">展开</span>
              <img style="width:14px;height:7px;cursor: pointer;transform:rotate(180deg)" src="@/assets/images/arrow-up.png" alt>
            </div>
            <div v-if="show==true"  @click="handleClick(false)">
              <span style="padding-left:2px">收起</span>
              <img style="width:14px;height:7px;cursor: pointer;" src="@/assets/images/arrow-up.png" alt>
            </div>
        </div>
      </div>
    </div>
    <!-- <el-row class="elRow">
      <img v-if="show==false" style="width:50px;height:24px;cursor: pointer;" src="@/assets/images/arrow-down.png" @click="handleClick(true)" alt />
      <img v-if="show==true"  style="width:50px;height:24px;cursor: pointer;" src="@/assets/images/arrow-up.png"  @click="handleClick(false)" alt />
    </el-row> -->
  </div>


</template>

<script>
import { EventBus } from '../../utils/event-bus';
  export default {
    name: "index",
    data() {
      return {show: false}
    },
    props: {
      value: {
        type: Boolean,
        default: false

      }
    },

    methods: {
      handleClick(state) {
        this.show = state;
        this.$emit("input", this.show);
         this.$nextTick(()=>{
            var height = $(".main-top").outerHeight(true);
            this.$emit('searchBorderClick',height)
         })
      }
    }

  }
</script>

<style scoped lang="scss">
  .tips {
    color: #086BAF;
    text-align: center;
    text-decoration: #086BAF;
    margin-left: -20px;
    margin-right: 10px;
    cursor: pointer;
  }
  .search-wrap{
    display: flex;
    justify-content: space-between;
  }
  
  .elRow{
    margin-left: 16px;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #0066FF;
    line-height:32px;
    height: 32px;
    cursor: pointer;
    img{
      margin-top: -10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/SearchFormWrap/index.vue